import { Component, inject, DestroyRef, OnInit } from '@angular/core';

import { ButtonModule } from '@openng/optimus-ui/button';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { CommonModule } from '@angular/common';
import { SvgIconsComponent } from '../../../index';
import { ConfirmHelperService } from '../../../index';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfirmModalData } from '../../models/confirmation.models';
import { ConfirmationService } from '@openng/optimus-ui/api';

export interface ConfirmPopupData {
  icon: string;
  header: string;
  message: string;
  acceptLabel: string;
  acceptSeverity: 'primary' | 'danger';
  rejectLabel: string;
}

@Component({
  selector: 'app-confirm-popup',
  standalone: true,
  providers: [ConfirmationService],
  imports: [ButtonModule, ConfirmDialogModule, CommonModule, SvgIconsComponent],
  templateUrl: './confirm-popup.component.html',
  styleUrl: './confirm-popup.component.scss'
})
export class ConfirmPopupComponent implements OnInit {
  #confirmationService = inject(ConfirmationService);
  #confirmHelperService = inject(ConfirmHelperService);
  #destroyRef = inject(DestroyRef);

  icon: string = '';
  header: string = '';
  message: string = '';
  lotDeficiencyIds: string[] = [];
  acceptLabel: string = 'Confirm';
  acceptSeverity: 'primary' | 'danger' | 'success' = 'primary';
  rejectLabel: string | null = null;

  private showConfirmPopup(config: ConfirmModalData) {
    this.icon = config.icon;
    this.header = config.header;
    this.message = config.message;
    this.acceptLabel = config.acceptLabel;
    this.acceptSeverity = config.acceptSeverity;
    this.rejectLabel = config.rejectLabel;

    this.#confirmationService.confirm({
      icon: this.icon,
      header: this.header,
      message: this.message,
      accept: () => {
        this.#confirmHelperService.emitConfirm();
        this.#confirmationService.close();
      },
      reject: () => {
        this.#confirmHelperService.emitReject();
        this.#confirmationService.close();
      }
    });
  }

  ngOnInit() {
    this.#confirmHelperService.openModel$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
      next: (data: any) => {
        this.showConfirmPopup({
          icon: data.icon,
          header: data.header,
          message: data.message,
          acceptLabel: data.acceptLabel,
          acceptSeverity: data.acceptSeverity,
          rejectLabel: data.rejectLabel
        });
      }
    });
  }
}
